const listBonus = {
  payload: [
    {
      bondId: 1,
      title: "Descuento para Ancianos",
      business: "Supermercado La Esperanza",
      startDate: "2025-03-31T19:00:00",
      endDate: "2025-06-01T18:59:59",
      creationDate: "2025-03-31T11:41:37",
      status: true,
      linkBusinessImage:
        "https://ibliss-icons-dev.s3.amazonaws.com/imagenes/tienda_x.jpg",
      linkBondImage:
        "https://ibliss-icons-dev.s3.amazonaws.com/imagenes/bono_10.jpg",
      linkCodeImage:
        "https://ibliss-icons-dev.s3.amazonaws.com/imagenes/codigo_10.jpg",
      companyId: 1,
      termsAndConditions:
        "10% de descuento en productos seleccionados para mayores de 60 años.",
    },
    {
      bondId: 2,
      title: "Descuento para Ancianos",
      business: "Supermercado La Esperanza",
      startDate: "2025-03-31T19:00:00",
      endDate: "2025-06-01T18:59:59",
      creationDate: "2025-03-31T11:41:37",
      status: true,
      linkBusinessImage:
        "https://ibliss-icons-dev.s3.amazonaws.com/imagenes/tienda_x.jpg",
      linkBondImage:
        "https://ibliss-icons-dev.s3.amazonaws.com/imagenes/bono_10.jpg",
      linkCodeImage:
        "https://ibliss-icons-dev.s3.amazonaws.com/imagenes/codigo_10.jpg",
      companyId: 1,
      termsAndConditions:
        "10% de descuento en productos seleccionados para mayores de 60 años.",
    },
  ],
};

const deleteBond = {
  payload: "Bono eliminado exitosamente.",
};

export const service = {
  getAllBonus: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: listBonus }), 1000);
    }),

  deleteBond: () =>
    new Promise((resolve) => {
      setTimeout(resolve({ data: deleteBond }), 1000);
    }),

};
